module.exports = __webpack_public_path__ + "img/SDG-10-EN.46672e95.png";